export default {
	methods: {
		_removeOnResizeListener() {
			if (this.$data._onResizeHandler) {
				window.removeEventListener('resize', this.$data._onResizeHandler, true);
				this.$data._onResizeHandler = null;
			}
			if (this.$data._resizeObserver) {
				this.$data._resizeObserver.disconnect();
				this.$data._resizeObserver = null;
			}
		},
		/**
		 * used to listen to window resize, so we can update the position of the menu
		 * @param {*} args
		 * @param {*} callback
		 */
		_listenOnResize(args, callback) {
			this._removeOnResizeListener();
			this.$data._onResizeHandler = () => callback(args);
			this.$data._resizeObserver = new ResizeObserver(() => callback(args));
			this.$data._resizeObserver.observe(args.targetElement);
			window.addEventListener('resize', this.$data._onResizeHandler, true);
		},
		_removeOnScrollListener() {
			if (this.$data._onScrollHandler) {
				window.removeEventListener('scroll', this.$data._onScrollHandler, true);
				this.$data._onScrollHandler = null;
			}
		},
		/**
		 * used to listen to window scrolls, so we can update the position of the menu
		 * @param {*} args
		 * @param {*} callback
		 */
		_listenOnScroll(args, callback) {
			this._removeOnScrollListener();
			this.$data._onScrollHandler = () => callback(args);
			window.addEventListener('scroll', this.$data._onScrollHandler, true);
		},
	},
	data() {
		return { _onScrollHandler: null, _onResizeHandler: null };
	},
};
